<gb-floating-button
  icon="add"
  (click)="openCreateSiteAnnouncement()"
  label="SITE_ANNOUNCEMENTS.CREATE"
></gb-floating-button>

@if (showEmptyState$ | async) {
  <gb-empty-state
    titleTranslateKey="SITE_ANNOUNCEMENTS.EMPTY_STATE"
    subtitle="SITE_ANNOUNCEMENTS.EMPTY_STATE_SUBTITLE"
  ></gb-empty-state>
}

<div class="gb-limit-width">
  <div class="announcements-header">
    <h1 translate="SITE_ANNOUNCEMENTS.TITLE"></h1>
    <span translate="SITE_ANNOUNCEMENTS.DESCRIPTION"></span>
  </div>
  <gb-table
    [loaded$]="loaded$"
    [displayedColumns$]="displayedColumns$"
    [tableData$]="allSiteAnnouncementsWithActions$"
    titleField="title"
    icon="notifications"
  ></gb-table>

  <mat-paginator
    #paginator
    [pageSize]="limit"
    [length]="(allSiteAnnouncementsWithActions$ | async)?.length || 0"
    (page)="onPageChange($event)"
    [pageSizeOptions]="[5, 10, 20, 50, 100]"
  ></mat-paginator>
</div>
